import React, { useState } from 'react';
import Icon from '../AppIcon';

const LegalModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('impressum');

  const tabs = [
    { id: 'impressum', label: 'Impressum' },
    { id: 'datenschutz', label: 'Datenschutz' },
    { id: 'agb', label: 'AGB' },
    { id: 'widerruf', label: 'Widerrufsrecht' }
  ];

  const getTabContent = () => {
    switch (activeTab) {
      case 'impressum':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-primary mb-4">Impressum</h3>
            <div className="space-y-3 text-sm text-black">
              <div>
                <h4 className="font-semibold mb-2 text-black">Ragna Detailing</h4>
                <p className="text-black">Otto-Lilienthal-Straße 43<br />
                  46539 Dinslaken<br />
                  Deutschland</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Geschäftsführung</h4>
                <p className="text-black">Amjad Bakri & Ahmad Khatib</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Kontakt</h4>
                <p className="text-black">
                  Telefon: <a href="tel:0 2064 777722" className="text-accent hover:underline">0 2064 777722</a><br />
                  E-Mail: <a href="mailto:ragnadetailing@gmail.com" className="text-accent hover:underline">ragnadetailing@gmail.com</a>
                </p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Handelsregister</h4>
                <p className="text-black">Amtsgericht Duisburg<br />
                  HRB 12345</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Umsatzsteuer-ID</h4>
                <p className="text-black">DE123456789</p>
              </div>
            </div>
          </div>
        );

      case 'datenschutz':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-primary mb-4">Datenschutzerklärung</h3>
            <div className="space-y-3 text-sm text-black">
              <div>
                <h4 className="font-semibold mb-2 text-black">1. Verantwortlicher</h4>
                <p className="text-black">Ragna Detailing<br />
                  Otto-Lilienthal-Straße 43, 46539 Dinslaken<br />
                  E-Mail: ragnadetailing@gmail.com</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">2. Erhebung und Verarbeitung personenbezogener Daten</h4>
                <p className="text-black">Wir erheben und verarbeiten personenbezogene Daten nur, soweit dies zur Erbringung unserer Leistungen erforderlich ist oder Sie uns Ihre Einwilligung erteilt haben.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">3. Zweck der Datenverarbeitung</h4>
                <p className="text-black">Die Verarbeitung erfolgt zur Erfüllung von Verträgen, zur Kommunikation und zur Erbringung unserer Dienstleistungen.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">4. Ihre Rechte</h4>
                <p className="text-black">Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung und Datenübertragbarkeit.</p>
              </div>
            </div>
          </div>
        );

      case 'agb':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-primary mb-4">Allgemeine Geschäftsbedingungen</h3>
            <div className="space-y-3 text-sm text-black">
              <div>
                <h4 className="font-semibold mb-2 text-black">§ 1 Geltungsbereich</h4>
                <p className="text-black">Diese AGB gelten für alle Dienstleistungen der Ragna Detailing.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">§ 2 Leistungen</h4>
                <p className="text-black">Wir bieten professionelle Autopflege-Dienstleistungen wie NANO-Versiegelung, Lackreparatur, Politur und Reinigung an.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">§ 3 Preise und Zahlung</h4>
                <p className="text-black">Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer. Die Zahlung erfolgt nach Leistungserbringung.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">§ 4 Haftung</h4>
                <p className="text-black">Wir haften nur für Schäden, die auf Vorsatz oder grober Fahrlässigkeit beruhen.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">§ 5 Schlussbestimmungen</h4>
                <p className="text-black">Es gilt deutsches Recht. Gerichtsstand ist Dinslaken.</p>
              </div>
            </div>
          </div>
        );

      case 'widerruf':
        return (
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-primary mb-4">Widerrufsrecht</h3>
            <div className="space-y-3 text-sm text-black">
              <div>
                <h4 className="font-semibold mb-2 text-black">Widerrufsrecht</h4>
                <p className="text-black">Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Widerrufsfrist</h4>
                <p className="text-black">Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Widerrufsbelehrung</h4>
                <p className="text-black">Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Ragna Detailing, Otto-Lilienthal-Straße 43, 46539 Dinslaken, E-Mail: ragnadetailing@gmail.com) mittels einer eindeutigen Erklärung über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.</p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-black">Folgen des Widerrufs</h4>
                <p className="text-black">Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen.</p>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-primary">Rechtliche Informationen</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Schließen"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* Tabs */}
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id
                      ? 'border-accent text-accent'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Content */}
          <div className="p-6 overflow-y-auto max-h-[60vh]">
            {getTabContent()}
          </div>

          {/* Footer */}
          <div className="flex justify-end p-6 border-t border-gray-200 bg-gray-50">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
            >
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
